import React from 'react'
import Subtask from '../Subtasks/Subtask'
import './card-modal.css'
import Axios from 'axios';
import { baseUrl } from '../assets/Animations';


const CardModal = (props) => {

    const [newSubtasks, setNewSubtasks] = React.useState([])
    //const [reminderModal, setReminderModal] = React.useState(null)
    const [showDescription, setShowDescription] = React.useState(false)
    const [ownerPic, setOwnerPic] = React.useState('mmalogo.png')
    const [teacherList, setTeacherList] = React.useState([])
    const [reminderSlider, setReminderSlider] = React.useState(false)
    const [reminderDetails, setReminderDetails] = React.useState({name: '', description: '', dueDate: ''})

    React.useEffect(() => {
        setTheTabs()
        // window.addEventListener('keyup', lookForEnterKeyPress)
        // return () => {
        //     window.removeEventListener('keyup', lookForEnterKeyPress)
        // }
        getTeachers()
    }, [])

    React.useEffect(() => {
        setTheTabs()
    })

    React.useEffect(() => {
        getTeachers()
    }, [props.todo.whichSchool])

    React.useEffect(() => {
        setReminderDetails(prev => ({...prev, name: props.todo.todoName}))
        setReminderDetails(prev => ({...prev, description: props.todo.todoDescription}))
        setReminderDetails(prev => ({...prev, dueDate: props.todo.todoDueDate}))
    }, [props.todo])

    React.useEffect(() => {
        if(document.getElementById('card-modal__reminder-slider')) {
            if(reminderSlider) {
                document.getElementById('card-modal__reminder-slider').style.maxHeight = "500px" 
                document.getElementById('card-modal__reminder-slider').style.opacity = 1
            }
        }
    }, [reminderSlider])

    const getTeachers = () => {
        Axios.get(`${baseUrl}/rawteacherdata/${props.todo.whichSchool}`)
        .then((res) => setTeacherList(res.data))
        .catch((err) => console.log(err))
    }

    const lookForEnterKeyPress = (e) => {
        if(e.key === "Enter") {
            if(props.openModal) {
                if(!showDescription) {
                    setTimeout(() => {
                        props.closeModal()
                    }, 100)
                }
            }
        } else if (e.keyCode === 27) {
            if(props.openModal) {
                props.closeModal()
            }
        }
    }

    const setTheTabs = () => {
        if(document.getElementById('modal-view-tasks') && document.getElementById('modal-view-description')) {
            if(showDescription === false) {
                document.getElementById('modal-view-tasks').style.borderBottom = "2px solid #000"
                document.getElementById('modal-view-tasks').style.color = "#000"
                document.getElementById('modal-view-description').style.borderBottom = "1px solid rgb(146, 146, 146)"
                document.getElementById('modal-view-description').style.color = "rgb(146, 146, 146)"
            } else {
                document.getElementById('modal-view-tasks').style.borderBottom = "1px solid rgb(146, 146, 146)"
                document.getElementById('modal-view-tasks').style.color = "rgb(146, 146, 146)"
                document.getElementById('modal-view-description').style.borderBottom = "2px solid #000"
                document.getElementById('modal-view-description').style.color = "#000"
            }
        }
    }

    const changeTitle = (theValue) => {
        props.changeTitle ? props.changeTitle(theValue) : props.editCard('todoName', theValue)
    }
    const changeDesc = (theValue) => {
        props.changeTitle ? props.changeDesc(theValue) : props.editCard('todoDescription', theValue)
    }
    const changeAlarm = (theValue) => {
        props.setAlarm && props.setAlarm(theValue)
    }
    const changeSchool = (theValue) => {
        props.changeTheSchool ? props.changeTheSchool(theValue) : props.editCard('whichSchool', theValue)
    }
    const createTask = () => {
        let newName = document.getElementById('new-task-modal-title').value
        let newDesc = document.getElementById('new-task-modal-desc-details').value
        props.closeModal()
    }
    const addNewSubtask = () => {
        let newSubtask = { subtaskId: Math.random().toString(16).slice(2), subtaskName: 'New Subtask', subtaskDueDate: new Date(), subtaskAlarm: false, subtaskSubtasks: []}
        props.addNewSubtask(newSubtask)
    }
    const addBrandNewSubtask = () => {
        let newestSubtasks = newSubtasks
        let newSubtask = { subtaskId: Math.random().toString(16).slice(2), subtaskName: 'New Subtask', subtaskDueDate: '', subtaskAlarm: false, subtaskSubtasks: []}
        newestSubtasks.push(newSubtask)
        setNewSubtasks(newestSubtasks)
    }
    const changeSubtaskNameWithTodo = (theValue, theId) => {
        let theTodo = props.todo.todoId
        let whichList = props.todo.whichList

        props.changeSubtaskName(theValue, theId, theTodo, whichList)
    }
    const checkClose = (theId) => {
        if(theId === 'invis-card-modal-wrapper' || theId === 'card-modal') {
            props.closeModal()
        }
    }
    const deleteTheModal = () => {
        let todo = props.todo
        if(props.itsAWorkflow) {
            props.deleteWorkflow(props.todo)
        } else {
            props.deleteTask(todo)
            //props.closeModal()
        }
    }
    const deleteMySubtask = (subTaskId) => {
        props.deleteSubtask(subTaskId)
    }
    const deleteMy2xSub = (sub2xId, subTaskId) => {
        props.delete2xSub(sub2xId, subTaskId)

    }
    const addANewSubSub = (subId) => {
        props.addNewSubSub(subId)
    }
    const changeMySubSubName = (theValue, theSubSubId, theSubId) => {
        props.changeSubSubName(theValue, theSubSubId, theSubId)
    }
    const autoReset = (theValue) => {
        let nameId = 'new-task-modal-title-' + props.todo.todoId
        if(theValue === 'New Task...') {
            document.getElementById(nameId).value = ''
        }
    }
    const notesAutoReset = (theValue) => {
        let noteId = "admin-modal-desc-details"
        if(theValue === 'Notes...') {
            document.getElementById(noteId).value = ''
        }
    }
    const changeMyOwner = (theValue) => {
        props.changeOwner ? props.changeOwner(theValue) : props.editCard('todoOwner', theValue)
        if(props.todo.todoOwner === 'Bri') {
            setOwnerPic('brimassie.jpg')
        } else if (props.todo.todoOwner === 'Courtney') {
            setOwnerPic('courtneymalloy.jpg')
        } else {
            setOwnerPic('mmalogo.png')
        }
    }
    const changeMyDate = (theValue) => {
        props.changeDueDate ? props.changeDueDate(theValue) : props.editCard('todoDueDate', theValue)
    }
    const changeMySubtaskDueDate = (theValue, theSubId) => {
        props.changeSubtaskDueDate(theValue, theSubId)
    }
    const addAReminder = () => {
        var event = {
            'summary': reminderDetails.name,
            //'location': '800 Howard St., San Francisco, CA 94103',
            'description': reminderDetails.description,
            'start': {
              'dateTime': `${reminderDetails.dueDate}:00-04:00`,
              'timeZone': 'America/Chicago',
            },
            'end': {
              'dateTime': `${reminderDetails.dueDate}:30-04:00`,
              'timeZone': 'America/Chicago',
            },
            // 'recurrence': [
            //   'RRULE:FREQ=DAILY;COUNT=2'
            // ],
            // 'attendees': [
            //   {'email': 'lpage@example.com'},
            //   {'email': 'sbrin@example.com'},
            // ],
            'reminders': {
              'useDefault': false,
              'overrides': [
                {'method': 'email', 'minutes': 5},
                //{'method': 'popup', 'minutes': 5},
              ],
            },
          };
        Axios.put(`${baseUrl}/setareminder`, {
            theReminder: event,
        })
        .then(response => {
            if(response.status === 200) {
                setReminderSlider(false)
                setTimeout(() => {
                    alert('Reminder has been set!')
                }, 50)
            }
        })
        .catch(e => {
            console.log(e)
            props.setError({message: e.response.data, status: e.response.status})
        })
    }
    const addInstrument = (id) => {
        let updatedList = props.todo.instrumentList ? props.todo.instrumentList : []
        for(let i = 0; i < props.instList.length; i++) {
            if(id === props.instList[i].id) {
                updatedList.push(props.instList[i])
            }
        }
        props.editInstruments(updatedList)
        document.getElementById('admin-modal-inst-selector').value = ''
    }

    const addStudent = () => {
        let updatedList = props.todo.studentList ? props.todo.studentList : []
        updatedList.push({
            studentId: Math.random().toString(16).slice(2),
            studentName: 'Student Name',
            instrumentList: [],
            teacherList: [],
            introLesson: {
              date: '',
              isScheduled: false,
              hasBeenCalled: false
            },
          })
        props.editStudents(updatedList)
    }

    const editStudent = (id, value, theKey, secondKey) => {
        let updatedList = props.todo.studentList
        for(let i = 0; i < updatedList.length; i++) {
            if(updatedList[i].studentId === id) {
                if(secondKey) {
                    secondKey === 'date' ? updatedList[i].introLesson[secondKey] = value : updatedList[i].introLesson[secondKey] = value
                } else {
                    updatedList[i][theKey] = value
                }
            }
        }
        props.editStudents(updatedList)
    }

    const addTeacherToStudent = (id, name) => {
        let updatedList = props.todo.studentList
        for(let i = 0; i < teacherList.length; i++) {
            if(name === teacherList[i].Name) {
                for(let j = 0; j < updatedList.length; j++) {
                    if(id === updatedList[j].studentId) {
                        updatedList[j].teacherList.push({
                            TeacherID: teacherList[i].TeacherID,
                            Name: teacherList[i].Name,
                            ImageName: teacherList[i].ImageName
                        })
                    }
                }
            }
        }
        props.editStudents(updatedList)
        document.getElementById('admin-modal__student-list__teacher-input').value = ''
    }

    const addInstToStudent = (stuId, instId) => {
        let updatedList = props.todo.studentList
        for(let i = 0; i < props.instList.length; i++) {
            if(props.instList[i].id === instId) {
                for(let j = 0; j < updatedList.length; j++) {
                    if(updatedList[j].studentId === stuId) {
                        updatedList[j].instrumentList.push(props.instList[i])
                    }
                }
            }
        }
        props.editStudents(updatedList)
        document.getElementById('admin-modal__student-list__inst-input').value = ''
    }

    const removeInstFromStudent = (stuId, instId) => {
        let updatedList = props.todo.studentList
        for(let i = 0; i < updatedList.length; i++) {
            if(updatedList[i].studentId === stuId) {
                for(let j = 0; j < updatedList[i].instrumentList.length; j++) {
                    if(updatedList[i].instrumentList[j].id === instId) {
                        updatedList[i].instrumentList.splice(j, 1)
                    }
                }
            }
        }
        props.editStudents(updatedList)
    }

    const removeTeacherFromStudent = (studentId, id) => {
        let updatedList = props.todo.studentList
        for(let i = 0; i < updatedList.length; i++) {
            if(studentId === updatedList[i].studentId) {
                for(let j = 0; j < updatedList[i].teacherList.length; j++) {
                    if(id === updatedList[i].teacherList[j].TeacherID) {
                        updatedList[i].teacherList.splice(j, 1)
                    }
                }
            }
        }
        props.editStudents(updatedList)
    }

    const removeStudent = (id) => {
        let updatedList = props.todo.studentList
        for(let i = 0; i < updatedList.length; i++) {
            if(updatedList[i].studentId === id) {
                updatedList.splice(i, 1)
            }
        }
        props.editStudents(updatedList)
    }

    const closingReminderSlider = () => {
        document.getElementById('card-modal__reminder-slider').style.maxHeight = "0px"
        setTimeout(() => {
            document.getElementById('card-modal__reminder-slider').style.opacity = 0
        }, 250)
        setTimeout(() => {
            setReminderSlider(false)
        }, 300)
    }

    let nameId = 'new-task-modal-title-' + props.todo.todoId
    if (props.openModal === 'new') {
        return (
            <div className="card-modal" id="card-modal" >
                <div className="invis-card-modal-wrapper" id="invis-card-modal-wrapper" onClick={(e) => checkClose(e.target.id)}>
                <div className="card-modal-content" id="card-modal-content">
                    <div className="the-modal-x" onClick={() => props.closeModal()}>x</div>
                    <input className="new-task-modal-title admin-modal-title" id="new-task-modal-title" placeholder="New Task..." />
                    <textarea className="admin-modal-desc-details" id="new-task-modal-desc-details" placeholder="Notes..."/>
                    <div className="subtasks-area">
                        {newSubtasks.map(subTask => 
                        <Subtask
                            whichList = {props.whichList}
                            changeSubSubName={(theValue, theSubSubId, theSubId) => changeMySubSubName(theValue, theSubSubId, theSubId)}
                            addNewSubSub={(subId) => addANewSubSub(subId)}
                            delete2xSub={(sub2xId, subTaskId) => deleteMy2xSub(sub2xId, subTaskId)}
                            deleteSubtask={(subTaskId) => deleteMySubtask(subTaskId)}
                            //BELOW THE FUNCTION USED TO BE CALLED changeMySubtaskNameWithTodo
                            changeSubtaskName={(theValue, theSubId) => changeSubtaskNameWithTodo(theValue, theSubId)}
                            subTask={subTask}
                        />)}
                        <div className="add-new-subtask" onClick={() => addBrandNewSubtask()}>+ Add Subtask</div>
                    </div>
                    <div className="create-task-btn" onClick={() => createTask()}>Add Task</div>
                </div>
                </div>
            </div>
        )
    } else if (props.openModal !== false) {
        let finalDateFormat = ''
        let currentDueDate = props.todo.todoDueDate
        function createDate() {
            let todaysDate = new Date(currentDueDate)
            let theMonth = ''
            let todaysMonth = todaysDate.getMonth() + 1
            if(todaysMonth < 10) {
                theMonth = `0${todaysMonth}`
            } else {
                theMonth = todaysMonth
            }
            let theDay = ''
            if(todaysDate.getDate() < 10) {
                theDay = `0${todaysDate.getDate()}`
            } else {
                theDay = todaysDate.getDate()
            }
            finalDateFormat = `${todaysDate.getFullYear()}-${theMonth}-${theDay}T10:00:00`
        }
        createDate()
        if(props.template){
            return (
                <div className="card-modal" id="card-modal">
                    <div className="invis-card-modal-wrapper" id="invis-card-modal-wrapper" onClick={(e) => checkClose(e.target.id)}>
                        <div className="card-modal-content template-look" id="card-modal-content">
                            <div className="the-modal-x" onClick={() => props.closeModal()}>X</div>
                            <input className="admin-modal-title" id={nameId} value={props.todo.todoName} onChange={(e) => changeTitle(e.target.value)} onClick={(e) => autoReset(e.target.value)}/>
                            <div className="two-sections-divider">
                                <div className="modal-view-tabs" id="modal-view-tasks" onClick={() => setShowDescription(false)}>Tasks</div>
                                <div className="modal-view-tabs" id="modal-view-description" onClick={() => setShowDescription(true)}>Description</div>
                            </div>
                            {showDescription && 
                                    <textarea className="admin-modal-desc-details" placeholder="Write notes here..." id="admin-modal-desc-details" value={props.todo.todoDescription} onClick={(e) => notesAutoReset(e.target.value)} onChange={(e) => changeDesc(e.target.value)}/>
                            }
                            {!showDescription && 
                            <div className="subtasks-area">
                                {props.todo.todoSubtasks.map(subTask => 
                                <Subtask
                                    key={subTask.subtaskId}
                                    whichList = {props.whichList}
                                    changeSubSubName={(theValue, theSubSubId, theSubId) => changeMySubSubName(theValue, theSubSubId, theSubId)}
                                    addNewSubSub={(subId) => addANewSubSub(subId)}
                                    delete2xSub={(sub2xId, subTaskId) => deleteMy2xSub(sub2xId, subTaskId)}
                                    deleteSubtask={(subTaskId) => deleteMySubtask(subTaskId)}
                                    changeSubtaskName={changeSubtaskNameWithTodo} 
                                    subTask={subTask}
                                    changeSubtaskDueDate={changeMySubtaskDueDate} 
                                />)}
                                <div className="add-new-subtask" onClick={() => addNewSubtask()}>+ Add Subtask</div>
                            </div>}
                            <div className="modal-button-wrapper">
                                    <div className="modal-delete-button" onClick={() => deleteTheModal()}></div>
                                    {props.editWorkflow ? <div className="modal-save-button" onClick={() => props.createNewWorkflowTemplate()}>Update Template</div> : <div className="modal-save-button" onClick={() => props.createNewWorkflowTemplate()}>Create Template</div>}
                            </div>
                        </div>
                    </div>
                </div>
            ) 
        } else {
            return (
                <div className="card-modal" id="card-modal">
                    <div className="invis-card-modal-wrapper" id="invis-card-modal-wrapper" onClick={(e) => checkClose(e.target.id)}>
                        <div className="card-modal-content" id="card-modal-content">
                            {reminderSlider &&
                                <div className='card-modal__reminder-slider' id="card-modal__reminder-slider">
                                    <div className='card-modal__reminder-slider__close-x__wrapper' onClick={() => closingReminderSlider(false)}>
                                        <div className='card-modal__reminder-slider__close-x'>close</div>
                                    </div>
                                    <div className='card-modal__reminder-slider__header'>Set A Reminder</div>
                                    <div className='card-modal__reminder-slider__input-labels'>Reminder Name</div>
                                    <input className='card-modal__reminder-slider__reminder-name' value={reminderDetails.name} onChange={(e) => setReminderDetails({...reminderDetails, name: e.target.value})} />
                                    <div className='card-modal__reminder-slider__input-labels'>Reminder Description</div>
                                    <textarea className='card-modal__reminder-slider__reminder-description' value={reminderDetails.description} onChange={(e) => setReminderDetails({...reminderDetails, description: e.target.value})} />
                                    <div className='card-modal__reminder-slider__input-labels'>Reminder Due Date</div>
                                    <input className='card-modal__reminder-slider__reminder-due-date' value={reminderDetails.dueDate} onChange={(e) => setReminderDetails({...reminderDetails, dueDate: e.target.value})} type="datetime-local" placeholder='yyyy-mm-ddT00:00' defaultValue={finalDateFormat}></input>
                                    <div className='card-modal__reminder-slider__submit-reminder' onClick={() => addAReminder()}>Create Reminder</div>
                                </div>
                            }
                            <div className="the-modal-x" onClick={() => props.closeModal()}>X</div>
                            <input className="admin-modal-title" id={nameId} value={props.todo.todoName} onChange={(e) => changeTitle(e.target.value)} onClick={(e) => autoReset(e.target.value)}/>
                            <div className="card-info-wrapper">
                                {props.todo.todoOwner === 'Bri' && <img src='brimassie.jpg' alt="owner-pic" className="owner-image"/>}
                                {props.todo.todoOwner === 'Courtney' && <img src='courtneymalloy.jpg' alt="owner-pic" className="owner-image"/>}
                                {/* {props.todo.todoOwner === 'Prescott' && <img src='prescottblackler.jpg' alt="owner-pic" className="owner-image"/>} */}
                                {props.todo.todoOwner === '' && <img src='mmalogo.png' alt="owner-pic" className="owner-image"/>}
                                {props.todo.todoOwner === 'Everyone' && <img src='mmalogo.png' alt="owner-pic" className="owner-image"/>}
                                <p className="assigned-to">Assigned to:</p>
                                <select className="task-owner-selector"  value={props.todo.todoOwner} onChange={(e) => changeMyOwner(e.target.value)}>
                                    <option default value="Everyone">Everyone</option>
                                    <option value="Bri">Bri</option>
                                    <option value="Courtney">Courtney</option>
                                    {/* <option value="Prescott">Prescott</option> */}
                                </select>
                                <p className="school-to">School:</p>
                                <select className="task-school-selector" value={props.todo.whichSchool} onChange={(e) => changeSchool(e.target.value)}>
                                    <option default value={'all'}>ALL</option>
                                    <option value="mma">MMA</option>
                                    <option value="lsma">LSMA</option>
                                    <option value="tma">TSMA</option>
                                    <option value="mor">MOR</option>
                                    <option value="psma">PSMA</option>
                                    {/* <option value="glma">GLMA</option> */}
                                </select>
                                <input type="datetime-local" className="date-selector" defaultValue={finalDateFormat} onChange={(e) => changeMyDate(e.target.value)}></input>
                                <div className="new-set-reminder-btn" onClick={() => setReminderSlider(true)}>Reminder Settings</div>
                            </div>
                            <div className="two-sections-divider">
                                <div className="modal-view-tabs" id="modal-view-tasks" onClick={() => setShowDescription(false)}>Tasks</div>
                                <div className="modal-view-tabs" id="modal-view-description" onClick={() => setShowDescription(true)}>Intro Lesson(s)</div>
                            </div>
                            {showDescription && 
                                <div className='admin-modal-desc-wrapper__new'>
                                    <div className='admin-modal-desc__inst-area'>
                                        {props.todo.studentList && 
                                            <div className='admin-modal__student-area'>
                                                {props.todo.studentList.map((student) => (
                                                    <div key={student.studentId} className='admin-modal__student-list__row'>
                                                        <div>
                                                            <div className='admin-modal__inst-list__chip__x' onClick={() => removeStudent(student.studentId)}>x</div>
                                                        </div>
                                                        <div className='admin-modal__student-list__info'>
                                                            <input className='admin-modal__student-list__name-input' value={student.studentName} onChange={(e) => editStudent(student.studentId, e.target.value, 'studentName')} />
                                                            {student.introLesson.isScheduled && <input type="datetime-local" className="admin-modal__student-list__date-input" placeholder='yyyy-mm-ddT00:00' defaultValue={finalDateFormat} value={student.introLesson.date} onChange={(e) => editStudent(student.studentId, e.target.value, 'introLesson', 'date')}></input>}
                                                            <div className='admin-modal__student-list__instrument-list__wrapper'>
                                                                {student.instrumentList.map((inst) => (
                                                                    <div key={inst.id} className="admin-modal__student-list__instrument-list__inst-card" >
                                                                        <div className="admin-modal__student-list__instrument-list__inst-card__name">{inst.name}</div>
                                                                        <div className="admin-modal__student-list__instrument-list__inst-card__remove" onClick={() => removeInstFromStudent(student.studentId, inst.id)}>x</div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className='admin-modal__student-list__add-wrapper'>
                                                                <select className='admin-modal__student-list__teacher-input' id='admin-modal__student-list__teacher-input' onChange={(e) => addTeacherToStudent(student.studentId, e.target.value)}>
                                                                    <option value=''>Add Teacher</option>
                                                                    { teacherList.length > 0 ? teacherList.map((teacher) => (
                                                                        <option value={teacher.Name}>{teacher.Name}</option>
                                                                    ))
                                                                    :
                                                                    <option>Choose School on Card</option>
                                                                    }
                                                                </select>
                                                                <select className='admin-modal__student-list__teacher-input' id='admin-modal__student-list__inst-input' onChange={(e) => addInstToStudent(student.studentId, e.target.value)}>
                                                                    <option value=''>Add Instrument</option>
                                                                    {props.instList.map((inst) => (
                                                                        <option value={inst.id}>{inst.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <div className='admin-modal__student-list__all-switches'>
                                                                <div className='admin-modal__student-list__switch-wrapper'>
                                                                    <div className='admin-modal__student-list__switch-label'>Intro Scheduled</div>
                                                                    {student.introLesson.isScheduled ? 
                                                                        <svg cursor="pointer" onClick={() => editStudent(student.studentId, false, 'introLesson', 'isScheduled')} className="admin-modal__student-list__switch-svg" viewBox="0 0 512 512">
                                                                            <g>
                                                                                <g>
                                                                                    <path fill="green" d="M376.5,120.5h-241C60.785,120.5,0,181.285,0,256s60.785,135.5,135.5,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                                                                        S451.215,120.5,376.5,120.5z M376.5,361.5C318.327,361.5,271,314.174,271,256c0-58.172,47.327-105.5,105.5-105.5
                                                                                        c58.173,0,105.5,47.328,105.5,105.5C482,314.174,434.673,361.5,376.5,361.5z"/>
                                                                                </g>
                                                                            </g>
                                                                        </svg>
                                                                        : 
                                                                        <svg cursor="pointer" onClick={() => editStudent(student.studentId, true, 'introLesson', 'isScheduled')} className="admin-modal__student-list__switch-svg" viewBox="0 0 511.999 511.999">
                                                                            <g>
                                                                                <g>
                                                                                    <path fill="rgba(150, 150, 150, 1)" d="M376.499,120.5h-241C60.784,120.5,0,181.286,0,256s60.784,135.5,135.499,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                                                                        S451.214,120.5,376.499,120.5z M135.499,361.501C77.326,361.501,30,314.173,30,256c0-58.173,47.326-105.5,105.499-105.5
                                                                                        c58.173,0,105.5,47.327,105.5,105.5C240.999,314.173,193.672,361.501,135.499,361.501z"/>
                                                                                </g>
                                                                            </g>
                                                                        </svg>
                                                                    } 
                                                                </div>
                                                                <div className='admin-modal__student-list__switch-wrapper'>
                                                                    <div className='admin-modal__student-list__switch-label'>Family Called</div>
                                                                    {student.introLesson.hasBeenCalled ? 
                                                                        <svg cursor="pointer" onClick={() => editStudent(student.studentId, false, 'introLesson', 'hasBeenCalled')} className="admin-modal__student-list__switch-svg" viewBox="0 0 512 512">
                                                                            <g>
                                                                                <g>
                                                                                    <path fill="green" d="M376.5,120.5h-241C60.785,120.5,0,181.285,0,256s60.785,135.5,135.5,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                                                                        S451.215,120.5,376.5,120.5z M376.5,361.5C318.327,361.5,271,314.174,271,256c0-58.172,47.327-105.5,105.5-105.5
                                                                                        c58.173,0,105.5,47.328,105.5,105.5C482,314.174,434.673,361.5,376.5,361.5z"/>
                                                                                </g>
                                                                            </g>
                                                                        </svg>
                                                                        : 
                                                                        <svg cursor="pointer" onClick={() => editStudent(student.studentId, true, 'introLesson', 'hasBeenCalled')} className="admin-modal__student-list__switch-svg" viewBox="0 0 511.999 511.999">
                                                                            <g>
                                                                                <g>
                                                                                    <path fill="rgba(150, 150, 150, 1)" d="M376.499,120.5h-241C60.784,120.5,0,181.286,0,256s60.784,135.5,135.499,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                                                                        S451.214,120.5,376.499,120.5z M135.499,361.501C77.326,361.501,30,314.173,30,256c0-58.173,47.326-105.5,105.499-105.5
                                                                                        c58.173,0,105.5,47.327,105.5,105.5C240.999,314.173,193.672,361.501,135.499,361.501z"/>
                                                                                </g>
                                                                            </g>
                                                                        </svg>
                                                                    } 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='admin-modal__student-list__teachers'>
                                                            {student.teacherList.map((teacher) => (
                                                                <div className='admin-modal__teacher-list__card'>
                                                                    <div className='admin-modal__teacher-list__remove-teacher' onClick={() => removeTeacherFromStudent(student.studentId, teacher.TeacherID)}>x</div>
                                                                    <img className='admin-modal__teacher-list__image' src={`https://app.atharo.app/images/${teacher.ImageName}`} />
                                                                    <div className='admin-modal__teacher-list__name'>{teacher.Name.split(' ')[0]}</div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )) }
                                            </div>
                                        }
                                    </div>
                                    {props.todo.studentList && props.todo.whichList !== 'inquiry' &&
                                        <div className='admin-modal__add-student' onClick={() => addStudent()}>Add Student</div>
                                    }
                                    {props.todo.whichList === 'inquiry' && <textarea className="admin-modal-desc-details" placeholder="Write notes here..." id="admin-modal-desc-details" value={props.todo.todoDescription} onClick={(e) => notesAutoReset(e.target.value)} onChange={(e) => changeDesc(e.target.value)}/>}
                                </div>
                            }
                            {!showDescription && 
                            <div className="subtasks-area">
                                {props.todo.todoSubtasks.map(subTask => 
                                <Subtask
                                    key={subTask.subtaskId}
                                    whichList = {props.whichList}
                                    changeSubSubName={(theValue, theSubSubId, theSubId) => changeMySubSubName(theValue, theSubSubId, theSubId)}
                                    addNewSubSub={(subId) => addANewSubSub(subId)}
                                    delete2xSub={(sub2xId, subTaskId) => deleteMy2xSub(sub2xId, subTaskId)}
                                    deleteSubtask={(subTaskId) => deleteMySubtask(subTaskId)}
                                    changeSubtaskName={changeSubtaskNameWithTodo} 
                                    subTask={subTask}
                                    changeSubtaskDueDate={changeMySubtaskDueDate} 
                                />)}
                                <div className="add-new-subtask" onClick={() => addNewSubtask()}>+ Add Subtask</div>
                            </div>}
                            {props.todo.whichList === 'inquiry' && 
                                <div className='courtney-call-alarm__switch-wrapper'>
                                    <div>Have Courtney Call:</div>
                                    {props.todo.todoAlarm ?
                                        <svg cursor="pointer" onClick={() => changeAlarm(false)} className="courtney-call__switch" viewBox="0 0 512 512">
                                            <g>
                                                <g>
                                                    <path fill="green" d="M376.5,120.5h-241C60.785,120.5,0,181.285,0,256s60.785,135.5,135.5,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                                        S451.215,120.5,376.5,120.5z M376.5,361.5C318.327,361.5,271,314.174,271,256c0-58.172,47.327-105.5,105.5-105.5
                                                        c58.173,0,105.5,47.328,105.5,105.5C482,314.174,434.673,361.5,376.5,361.5z"/>
                                                </g>
                                            </g>
                                        </svg>
                                        : 
                                        <svg cursor="pointer" onClick={() => changeAlarm(true)} className="courtney-call__switch" viewBox="0 0 511.999 511.999">
                                            <g>
                                                <g>
                                                    <path fill="rgba(150, 150, 150, 1)" d="M376.499,120.5h-241C60.784,120.5,0,181.286,0,256s60.784,135.5,135.499,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                                        S451.214,120.5,376.499,120.5z M135.499,361.501C77.326,361.501,30,314.173,30,256c0-58.173,47.326-105.5,105.499-105.5
                                                        c58.173,0,105.5,47.327,105.5,105.5C240.999,314.173,193.672,361.501,135.499,361.501z"/>
                                                </g>
                                            </g>
                                        </svg>
                                    }
                                </div>
                            }
                            <div className="modal-button-wrapper">
                                    <div className="modal-delete-button" onClick={() => deleteTheModal()}></div>
                                    <div className="modal-save-button" onClick={() => props.closeModal()}>Save</div>
                            </div>
                        </div>
                    </div>
                </div>
            ) 
        }
    } else {
        return null
    }
}
export default CardModal